import { AppService } from '@aperza/util';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import style from './BrandHeader.module.scss';
import { addUtmParam } from '../addUtmParam';
import { useAperzaUserContext } from './AperzaUserContext';
import { Tooltip } from '../util/Tooltip';
export const headerBrands = [
    {
        logo: `${AppService.staticServerHost()}/common/images/aperza2022/black/logo.svg`,
        logoHover: `${AppService.staticServerHost()}/common/images/aperza2022/red/logo.svg`,
        name: 'アペルザポータル',
        url: AppService.wwwServerHost(),
        width: 60,
        height: 20,
    },
    {
        logo: `${AppService.staticServerHost()}/common/images/aperza2022/black/logo_tv.svg`,
        logoHover: `${AppService.staticServerHost()}/common/images/aperza2022/red/logo_tv.svg`,
        name: 'アペルザTV',
        url: AppService.tvServerHost(),
        width: 81,
        height: 20,
    },
    {
        logo: `${AppService.staticServerHost()}/common/images/aperza2022/black/logo_catalog.svg`,
        logoHover: `${AppService.staticServerHost()}/common/images/aperza2022/red/logo_catalog.svg`,
        name: 'アペルザカタログ',
        url: `${AppService.wwwServerHost()}/catalog/`,
        width: 117,
        height: 20,
    },
    {
        logo: `${AppService.staticServerHost()}/common/images/aperza2022/black/logo_news.svg`,
        logoHover: `${AppService.staticServerHost()}/common/images/aperza2022/red/logo_news.svg`,
        name: 'アペルザニュース',
        url: AppService.newsServerHost(),
        width: 100,
        height: 20,
    },
    {
        logo: `${AppService.staticServerHost()}/common/images/aperza2022/black/logo_ec.svg`,
        logoHover: `${AppService.staticServerHost()}/common/images/aperza2022/red/logo_ec.svg`,
        name: 'アペルザEC',
        url: AppService.ecServerHost(),
        width: 81,
        height: 20,
    },
    {
        isDivider: true,
    },
    {
        logo: `${AppService.staticServerHost()}/common/images/aperza2022/black/logo_dx.svg`,
        logoHover: `${AppService.staticServerHost()}/common/images/aperza2022/red/logo_dx.svg`,
        name: 'アペルザDX',
        url: AppService.cloudServerHost(),
        width: 82,
        height: 20,
    },
];
export default function BrandHeader({ fixed }) {
    const { serviceType } = useAperzaUserContext();
    const [hideBrand, setHideBrand] = useState(false);
    const brandRef = useRef(null);
    const scrollCheck = useCallback(() => {
        const posY = window.scrollY;
        if (posY > 0 && !hideBrand) {
            setHideBrand(true);
        }
        if (posY === 0 && hideBrand) {
            setHideBrand(false);
        }
    }, [hideBrand]);
    useEffect(() => {
        const initScrollY = window.scrollY;
        if (initScrollY > 0) {
            setHideBrand(true);
        }
    }, []);
    useEffect(() => {
        if (fixed) {
            document.addEventListener('scroll', scrollCheck);
            return () => {
                document.removeEventListener('scroll', scrollCheck);
            };
        }
        return () => { };
    }, [scrollCheck, fixed]);
    return (React.createElement(CSSTransition, { ref: brandRef, in: !hideBrand, unmountOnExit: true, timeout: 200, classNames: {
            enter: style.brandEnter,
            enterActive: style.brandEnterActive,
            exitActive: style.brandExitActive,
        } },
        React.createElement("div", { id: "brand-header", className: style.brandHeader, ref: brandRef },
            React.createElement("p", { className: style.brandHeaderTitle }, "\u3082\u306E\u3065\u304F\u308A\u7523\u696D\u5411\u3051\u30DD\u30FC\u30BF\u30EB\u30B5\u30A4\u30C8 Ap\u00E9rza\uFF08\u30A2\u30DA\u30EB\u30B6\uFF09"),
            React.createElement("div", { className: style.brandHeaderService }, headerBrands.map((brand) => {
                if (brand.isDivider) {
                    return (React.createElement("div", { style: { width: 1, height: 15, backgroundColor: '#d7d7d7', margin: '0 6px' }, key: "divider" }));
                }
                return (React.createElement("div", { key: brand.name, className: style.brandWrapper, style: { width: brand.width, height: brand.height } },
                    React.createElement(Tooltip, { tooltip: brand.name },
                        React.createElement("a", { href: addUtmParam(brand.url, 'header', serviceType), target: "_blank", className: style.brandLink },
                            React.createElement("img", { alt: brand.name, src: brand.logo, className: style.defaultImg, width: brand.width, height: brand.height }),
                            React.createElement("img", { alt: brand.name, src: brand.logoHover, className: style.hoverImg, width: brand.width, height: brand.height })))));
            })))));
}
